<form
  [formGroup]="form"
  NFFormValidation
  (validSubmit)="onSubmit()"
  id="find-bulk-transactions-form"
>
  <div class="start-end-dates">
    <nf-form-control
      compact
      label="Begin Recon Date Range"
      [customErrorMessages]="dateRangeErrorMessages.dateDiffValidationMessages"
    >
      <nf-datepicker
        [formControl]="startDate"
        [format]="dateFormat"
        (dateSelect)="onStartDateSelect()"
        container="#find-bulk-transactions-form"
        #startDatePicker
      ></nf-datepicker>
    </nf-form-control>
    <nf-form-control
      compact
      label="End Recon Date Range"
      [customErrorMessages]="dateRangeErrorMessages.dateDiffValidationMessages"
    >
      <nf-datepicker
        [formControl]="endDate"
        [format]="dateFormat"
        container="#find-bulk-transactions-form"
        (dateSelect)="onEndDateSelect()"
        #endDatePicker
      ></nf-datepicker>
    </nf-form-control>
  </div>
  <hr />
  <nf-form-control label="Root IDs" compact aria-required="true">
    <nf-radio-group [formControl]="rootIdType">
      <nf-radio-button
        label="Account IDs"
        value="account"
        [inline]="true"
      ></nf-radio-button>
      <!-- This will be added back once the work is done in the backend -->
      <!-- <nf-radio-button
        label="Aggregate IDs"
        value="aggregate"
        [inline]="true"
      ></nf-radio-button> -->
      <nf-radio-button
        label="Client IDs"
        value="client"
        [inline]="true"
      ></nf-radio-button>
      <nf-radio-button
        label="Transaction IDs"
        value="transaction"
        [inline]="true"
      ></nf-radio-button>
    </nf-radio-group>
    <input type="text" class="form-control" required [formControl]="rootIds" />
  </nf-form-control>
  <hr />
  <div class="side-by-side-input-field">
    <nf-form-control label="Asset ID" compact>
      <input type="text" class="form-control" [formControl]="assetIds" />
    </nf-form-control>
    <nf-form-control label="Transaction Type(s)" compact>
      <ng-select
        [formControl]="transactionTypes"
        [items]="bulkExtTranTypes"
        bindLabel="name"
        bindValue="code"
        [multiple]="true"
        class="multi-select"
        placeholder="Select Transaction Type"
        clearAllText="Clear"
        [clearable]="true"
        [clearOnBackspace]="true"
        [closeOnSelect]="false"
        groupBy="selectedAllGroup"
        [selectableGroup]="true"
        [selectableGroupAsModel]="false"
      >
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div
            *ngIf="items.length > 1; else singleItem"
            class="ng-value nf-custom-badge"
          >
            <span class="ng-value-label">
              {{ items.length }} types selected
            </span>
          </div>
          <ng-template #singleItem>
            <div class="ng-value nf-custom-badge">
              <span
                class="ng-value-label"
                *ngFor="
                  let item of items;
                  index as i;
                  trackBy: trackTranTypeByType
                "
                >{{ item.name }}</span
              >
            </div>
          </ng-template>
        </ng-template>

        <ng-template
          ng-optgroup-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <input
            id="item-{{ index }}"
            type="checkbox"
            [checked]="item$.selected"
          />
          Select All
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <input
            id="item-{{ index }}"
            type="checkbox"
            [checked]="item$.selected"
          />
          {{ item.name }} ({{ item.code }})
        </ng-template>
      </ng-select>
    </nf-form-control>
  </div>
  <div class="side-by-side-input-field">
    <nf-form-control label="Data Source(s)" compact>
      <ng-select
        [formControl]="dataSources"
        [items]="bulkDataSources"
        bindLabel="name"
        bindValue="key"
        class="multi-select"
        placeholder="Select Data Source"
        clearAllText="Clear"
        [clearable]="true"
        [clearOnBackspace]="true"
        [closeOnSelect]="false"
      >
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div
            *ngIf="items.length > 1; else singleItem"
            class="ng-value nf-custom-badge"
          >
            <span class="ng-value-label">
              {{ items.length }} types selected
            </span>
          </div>
          <ng-template #singleItem>
            <div class="ng-value nf-custom-badge">
              <span
                class="ng-value-label"
                *ngFor="
                  let item of items;
                  index as i;
                  trackBy: trackTranTypeByType
                "
                >{{ item }}</span
              >
            </div>
          </ng-template>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div container="body" class="ellipsis">
            {{ item }}
          </div>
        </ng-template>
      </ng-select>
    </nf-form-control>

    <nf-form-control label="Status(es)" compact>
      <ng-select
        [formControl]="transactionStatus"
        [items]="bulkTransactionStatus"
        bindLabel="name"
        bindValue="key"
        [multiple]="true"
        class="multi-select"
        placeholder="Select Status"
        clearAllText="Clear"
        [clearable]="true"
        [clearOnBackspace]="true"
        [closeOnSelect]="false"
      >
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div
            *ngIf="items.length > 1; else singleItem"
            class="ng-value nf-custom-badge"
          >
            <span class="ng-value-label">
              {{ items.length }} types selected
            </span>
          </div>
          <ng-template #singleItem>
            <div class="ng-value nf-custom-badge">
              <span
                class="ng-value-label"
                *ngFor="
                  let item of items;
                  index as i;
                  trackBy: trackTranTypeByType
                "
                >{{ item }}</span
              >
            </div>
          </ng-template>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div container="body" class="ellipsis">
            {{ item }}
          </div>
        </ng-template>
      </ng-select>
    </nf-form-control>
  </div>
  <div *ngIf="!hasSingleUltimateParent">
    <div class="small ml-1" id="errorMessage">
      *Search is not within a single ultimate parent. Please revise search
      parameters.
    </div>
  </div>
  <div *ngIf="transactionLimitBreached">
    <div class="small ml-1" id="errorMessage">
      This panel supports searching for a maximum of
      {{ tranCountLimit }} transactions at a time. Please reduce the number of
      Tran IDs you are searching for.
    </div>
  </div>
  <div *ngIf="hasSingleUltimateParent && !ignoreUltParentCheck">
    <div class="mt-2">
      Search is within ultimate parent {{ ultimateParentDisplay }}
    </div>
  </div>
  <div
    *ngIf="
      hasSingleUltimateParent &&
      ignoreUltParentCheck &&
      !transactionLimitBreached
    "
  >
    <div class="mt-2">
      After you click 'Apply' it will check if ids are within the same Ultimate
      Parent ID
    </div>
  </div>
  <div class="d-flex flex-row justify-content-end mt-3">
    <button
      nf-button="submit"
      [loading]="isFormSubmitting"
      [disabled]="
        !hasSingleUltimateParent || !form.valid || transactionLimitBreached
      "
      (click)="onSubmit()"
    >
      Apply
    </button>
  </div>
</form>
